export default __webpack_public_path__ + "static/media/finishIllustration.fc767c07.png";